import { UxUiComponent } from './modules/landing/services/ux-ui/ux-ui.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './modules/landing/home/home.component';
import { WhoWeAreComponent } from './modules/landing/who-we-are/who-we-are.component';
import { ServicesComponent } from './modules/landing/services/services.component';
import { ProyectsComponent } from './modules/landing/proyects/proyects.component';
import { OnboardingComponent } from './modules/landing/onboarding/onboarding.component';
import { DigitalKitComponent } from './modules/landing/digital-kit/digital-kit.component';
import { JobsComponent } from './modules/landing/jobs/jobs.component';
import { ContactComponent } from './modules/landing/contact/contact.component';
import { MaintenanceComponent } from './modules/landing/services/maintenance/maintenance.component';
import { BusinessDevelopmentComponent } from './modules/landing/services/business-development/business-development.component';
import { InfrastructureComponent } from './modules/landing/services/infrastructure/infrastructure.component';
import { TechnologyConsultingComponent } from './modules/landing/services/technology-consulting/technology-consulting.component';
import { DigitalMarketingComponent } from './modules/landing/services/digital-marketing/digital-marketing.component';
import { AiConsultingComponent } from './modules/landing/services/ai-consulting/ai-consulting.component';
import { ConsultingProyectComponent } from './modules/landing/proyects/consulting-proyect/consulting-proyect.component';
import { DigitalGrowthProjectComponent } from './modules/landing/proyects/digital-growth-project/digital-growth-project.component';
import { DigitalExperienceProjectComponent } from './modules/landing/proyects/digital-experience-project/digital-experience-project.component';
import { TermsComponent } from './modules/landing/legal-advice/terms/terms.component';
import { LegalAdviceComponent } from './modules/landing/legal-advice/legal-advice.component';
import { PrivacyComponent } from './modules/landing/legal-advice/privacy/privacy.component';
import { CookiesComponent } from './modules/landing/legal-advice/cookies/cookies.component';

const routes: Routes = [
  { path: '', component: HomeComponent},
  { path: '**', redirectTo: 'home', pathMatch: 'full'},
  { path: 'quienes-somos', component: WhoWeAreComponent},
  { path: 'servicios', component: ServicesComponent,
    children: [
      { path: '', redirectTo: 'desarrollo-comercial', pathMatch: 'full'},
      { path: 'mantenimiento', component: MaintenanceComponent},
      { path: 'desarrollo-comercial', component: BusinessDevelopmentComponent},
      { path: 'infraestructura', component: InfrastructureComponent},
      { path: 'ux-ui', component: UxUiComponent},
      { path: 'consultoria-tecnologica', component: TechnologyConsultingComponent},
      { path: 'marketing-digital', component: DigitalMarketingComponent},
      { path: 'consultoria-ia', component: AiConsultingComponent}
    ],
  },
  { path: 'proyectos', component: ProyectsComponent,
    children: [
      { path: '', redirectTo: 'proyecto-consultoria', pathMatch: 'full'},
      { path: 'proyecto-consultoria', component: ConsultingProyectComponent},
      { path: 'proyecto-crecimiento-digital', component: DigitalGrowthProjectComponent},
      { path: 'proyecto-experiencia-digital', component: DigitalExperienceProjectComponent},
    ],
  },
  { path: 'productos', component: OnboardingComponent},
  { path: 'talento', component: JobsComponent},
  { path: 'kit-digital', component: DigitalKitComponent },
  { path: 'contacto', component: ContactComponent},
  { path: 'aviso-legal', component: LegalAdviceComponent,
    children: [
      { path: '', component: LegalAdviceComponent},
      { path: 'terminos', component: TermsComponent},
      { path: 'privacidad', component: PrivacyComponent},
      { path: 'cookies', component: CookiesComponent},
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
